export const feetsToMeters = (feets: number): number => {
  return feets * 0.3048;
};

